import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[ruleAutocompleteContent]'
})
export class RuleAutocompleteContentDirective {
  constructor( public tpl: TemplateRef<any> ) {
  }
}
